import { DependenciesInjection } from "app/di/DependencyInjection";
import { ActionLogRepositoryImpl } from "../data/ActionLogRepositoryImpl";
import { IActionLogRepository } from "../domain/repositories/IActionLogRepository";
import { ActionLogUseCase } from "../domain/useCases/ActionLogUseCase";
import { ActionLogViewModel } from "../presentation/viewModel/ActionLogViewModel";
import { ActionLogToken } from "./ActionLogToken";

export class ActionLogInjection {
  static initInjections() {
    DependenciesInjection.register<IActionLogRepository>(
      ActionLogToken.IActionLogRepository,
      ActionLogRepositoryImpl,
      "otherRepo",
    );
    DependenciesInjection.register<ActionLogUseCase>(
      ActionLogToken.ActionLogUseCase,
      ActionLogUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<ActionLogViewModel>(
      ActionLogToken.ActionLogViewModel,
      ActionLogViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IActionLogRepository>(
      ActionLogToken.IActionLogRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<ActionLogUseCase>(
      ActionLogToken.ActionLogUseCase,
    );
  }
}
